import { Badge, Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { MouseEvent } from 'react';
import type { DirLeadStatusType } from '@econtractor/types';
import { defLeadsStatus, useLead } from '../context/LeadProvider';
import { useSettings } from 'context/SettingsContext';
import { isSameIdSet } from 'utils/helpers/list/isSameIdSet';
import vconst from 'utils/helpers/structs/vconst';
import { tDirName } from 'utils/helpers/i18n/tDirName';
import SolarIcon from 'components/icons/SolarIcon';

const LeadFilterStatus = () => {
    const { t } = useTranslation(['Leads']);
    const { leadsSatus, setLeadStatus } = useLead();
    const { localSettings } = useSettings();
    const filterActive = !isSameIdSet(leadsSatus, defLeadsStatus);

    const handleClickStatus = (e: MouseEvent<HTMLElement>, statusID: number) => {
        e.currentTarget.blur();
        if (leadsSatus.includes(statusID)) setLeadStatus((prev) => prev.filter((ID) => ID != statusID));
        else setLeadStatus((prev) => [...prev, statusID]);

        e.stopPropagation();
    };

    return (
        <Dropdown>
            <Dropdown.Toggle
                className="fs-14 px-2 ms-1"
                size="sm"
                variant={filterActive ? 'danger' : 'primary'}
                id="dropdown-leads-filter"
                title={t('toolLeadFilter')}
            >
                <SolarIcon name="funnel" className="fs-14 p-0" />
            </Dropdown.Toggle>

            <Dropdown.Menu className="lead-filter-menu">
                {localSettings?.DIRS?.LeadStatus &&
                    localSettings.DIRS.LeadStatus.map((lStatus: DirLeadStatusType) => {
                        const statusStyle = lStatus.statusJson?.statusStyle || 'danger';
                        const isPostponed = Number(lStatus.ID) === vconst.leadPostponed;
                        return (
                            <Dropdown.Item
                                key={lStatus.ID}
                                className={isPostponed ? 'lead-filter-item--postponed' : undefined}
                                onClick={(e) => handleClickStatus(e, lStatus.ID)}
                            >
                                <div className="me-2">
                                    <input
                                        type="checkbox"
                                        checked={leadsSatus.includes(lStatus.ID)}
                                        onChange={() => null}
                                        className="form-check-input"
                                    />
                                </div>

                                <div className="lead-filter-item__content">
                                    <Badge className="fs-12" bg={statusStyle}>
                                        {tDirName(t, lStatus.i18nKey, lStatus.statusName) ||
                                            t(`status.${lStatus.ID}`)}
                                    </Badge>
                                    {isPostponed ? (
                                        <span className="lead-filter-item__hint">
                                            {t('filterPostponedHint')}
                                        </span>
                                    ) : null}
                                </div>
                            </Dropdown.Item>
                        );
                    })}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default LeadFilterStatus;
